const getFormDataAsObject = require("../form/getFormDataAsObject");

/**
 * @param formId {string}
 * @returns {undefined | object}
 */
module.exports = function getForm1262Data(formId) {
    const form = document.querySelector(`#${formId}`);

    if (form instanceof HTMLFormElement) {
        return getFormDataAsObject(form);
    }

    return undefined;
};
